export default __webpack_public_path__ + "static/media/titleBased.c94f0013.jpg";